import { selects } from '~/meta/data/selects.gql';
import { tableColumnMapper } from '~/utils';

// Tables
const columns = {
  leistung: {
    __graphqlType: 'Leistung',
    id: { header: 'Id', accessor: 'id' },
    description: { header: 'Bezeichnung', accessor: 'bezeichnung' },
    unit: { header: 'Einheit', accessor: 'einheit', width: 120 },
    type: { header: 'Typ', accessor: 'typSnippet.name' },
    controls: { accessor: 'controls', width: 60, renderer: { name: 'Controls' } },
  },
};

export const tables = {
  leistung: {
    columns: ['id', 'description', 'unit', 'type', 'controls'].map(tableColumnMapper(columns.leistung)),
    hiddenColumns: ['id'],
    tableProps: { pageSize: 15 },
  },
};

// Forms
export const fields = {
  leistung: {
    __graphqlInput: 'LeistungInput',
    description: { api: { path: 'bezeichnung', required: true } },
    unit: { api: { path: 'einheit', required: true } },
    type: { api: { path: 'typSnippetId', required: true } },
  },
};

export const forms = {
  leistung: [
    { path: 'description', ui: { label: 'Bezeichnung', colSpan: 2 } },
    { path: 'unit', ui: { label: 'Einheit' } },
    {
      path: 'type',
      ui: {
        label: 'Typ',
        component: 'QuerySelect',
        props: {
          query: selects.leistungTyp,
          placeholder: 'Typ wählen',
          orderBy: { name: 'asc' },
          variables: { filter: { kategoriePrefix: 'Leistung', eigenschaftPrefix: 'Typ' } },
          mapOptions: (item: any) => ({ value: item?.value, label: item?.label }),
        },
      },
    },
  ],
};
